import { Editor } from "grapesjs";
import store from "../../../state/store";

export function loadBlocks(editor: Editor)
{
	// ---- CUSTOM ----
	const blockDefinitions = store.getState().visageModule.blockDefinitions;
	if(blockDefinitions.blocks)
	{
		for(const [key, value] of Object.entries(blockDefinitions.blocks))
		{
			editor.BlockManager.add("custom-block-" + key, {
				label: value.displayName,
				media: `<img src="data:image/svg+xml;base64,${value.displayIcon}" />`,
				category: value.category,
				content: {},
				attributes: {
					customBlockDefinition: JSON.stringify(value),
				}
			});
		}
	}
}
